export const deleteAlertsBulkActionType = 'deleteAlerts';
